import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p>
          Desenvolvido por<a href="https://www.linkedin.com/in/jonathan-ws-costa" target="_blank" style={{ margin: "0 5px 0 5px" }} rel="noreferrer">Jonathan Costa</a> - ©CAÊ {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}